<template>
  <b-container fluid class="pb-5">
    <b-row>
      <b-col cols="3">
        <div class="box-pending-value">
          <div class="text-head">deposits today (all vaults)</div>
          <div class="text-body">$60,000</div>
        </div>
      </b-col>
      <b-col cols="3">
        <div class="box-pending-value">
          <div class="text-head">Withdrawals today (all vaults)</div>
          <div class="text-body">$42,000</div>
        </div>
      </b-col>
      <b-col cols="3">
        <div class="box-pending-value">
          <div class="text-head text-uppercase">TVL</div>
          <div class="text-body">$100,000,000</div>
        </div>
      </b-col>
      <b-col cols="3">
        <div class="box-pending-value">
          <div class="text-head">time til next maturity</div>
          <div class="text-body">2D 16H 43M</div>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col cols="12">
        <b-row>
          <b-col cols="9">
            <div class="box-graph">
              <div class="title-container">
                <h4 class="title-sub">Today's Trend</h4>
                <div class="second-title-sub">
                  <span>as of 25 May 2019, 09:41 PM</span>
                  <div class="chart-legend" v-html="htmlLegend">hehe</div>
                </div>
              </div>
              <line-chart
                :chartdata="this.chartdata"
                :options="this.options"
                @sendLegend="setLegend"
              />
            </div>
          </b-col>
          <b-col cols="3" class="pl-0">
            <b-row>
              <b-col cols="12" class="pl-0">
                <div class="box-stats">
                  <h5 class="title-sub">Statistic 1</h5>
                  <h6 class="title-sub-value">449</h6>
                </div>
                <div class="box-stats">
                  <h5 class="title-sub">Statistic 2</h5>
                  <h6 class="title-sub-value">426</h6>
                </div>
                <div class="box-stats">
                  <h5 class="title-sub">Statistic 3</h5>
                  <h6 class="title-sub-value">33</h6>
                </div>
                <div class="box-stats">
                  <h5 class="title-sub">Statistic 4</h5>
                  <h6 class="title-sub-value">300</h6>
                </div>
                <div class="box-stats">
                  <h5 class="title-sub">Statistic 5</h5>
                  <h6 class="title-sub-value">94</h6>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import LineChart from "../../components/Admin/charts/LineChart.vue";

export default {
  components: { LineChart },
  data() {
    return {
      htmlLegend: "",
      chartdata: {
        labels: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
        ],
        datasets: [
          {
            label: "Today",
            data: [40, 20, 33, 10, 99, 58, 87],
            borderColor: "#27AE60",
            tension: 0.4,
          },
          {
            label: "Yesterday",
            data: [65, 59, 80, 81, 56, 55, 40],
            borderColor: "#6171FF",
            tension: 0.4,
            bezierCurve: true,
          },
        ],
      },
      options: {
        //responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              display: true,
              position: "right",
              ticks: {
                beginAtZero: true,
              },
              //padding: -9,
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          align: "end",
          display: false,
        },
        legendCallback: function (chart) {
          var text = [];
          text.push("<ul>");
          for (var i = 0; i < chart.data.datasets.length; i++) {
            // see what's inside the obj.
            //
            text.push("<li>");
            text.push("<span>" + chart.data.datasets[i].label + "</span>");
            text.push("</li>");
          }
          text.push("</ul>");
          return text.join("");
        },
      },
    };
  },
  methods: {
    setLegend(html) {
      this.htmlLegend = html;
    },
  },
};
</script>

<style lang="scss" scoped>
.box-pending-value {
  font-family: Exo;
  font-style: normal;
  color: #222222;
  text-align: center;
  padding: 15px 6.5px; //1.0416666666666667vw 0.4513888888888889vw;
  display: flex;
  gap: 10px; //0.6944444444444444vw;
  flex-direction: column;
  border: 1px solid #eaedf0;
  box-sizing: border-box;
  border-radius: 4px; //0.2777777777777778vw;
  //   flex-basis: 272px; //18.88888888888889vw;
  min-height: 134px; //9.305555555555555vw;
  word-break: break-all;
  justify-content: space-around;

  .text-head {
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    letter-spacing: 0.5px;
    text-transform: capitalize;
    text-align: center;

    // @media only screen and (min-width: 1440px) {
    //     font-size: 0.9722222222222222vw;
    //     line-height: 1.3194444444444444vw;
    // }
  }
  .text-body {
    font-weight: bold;
    font-size: 30px;
    line-height: 39.87px;
    text-align: center;
    letter-spacing: 0.5px;
    text-transform: capitalize;

    // @media only screen and (min-width: 1440px) {
    //     font-size: 2.0833333333333335vw;
    //     line-height: 2.76875vw;
    // }
  }
}

.box-graph {
  border: 1px solid #eaedf0;
  padding: 11px 32px; //2.2222222222222223vw;
  margin-bottom: 73px; // 5.069444444444445vw;
  height: 90%;
  canvas {
    height: 464px !important;
  }
  .title-sub {
    font-size: 19px;
    line-height: 25.25px;
    letter-spacing: 0.4px;
    font-weight: 700;

    // @media only screen and (min-width: 1440px) {
    //     font-size: 1.3194444444444444vw;
    //     line-height: 1.7534722222222223vw;
    //     letter-spacing: 0.027777777777777776vw;
    // }

    & ~ .second-title-sub {
      display: flex;
      justify-content: space-between;

      span {
        font-size: 12px;
        line-height: 16px;

        // @media only screen and (min-width: 1440px) {
        //     font-size: 0.8333333333333334vw;
        //     line-height: 1.1111111111111112vw;
        // }
      }
    }
  }
}
.box-stats {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 114px; //7.916666666666667vw;
  border: 1px solid #eaedf0;
  padding: 15px 6.5px; //1.0416666666666667vw 0.4513888888888889vw;
  text-align: center;

  .title-sub {
    font-size: 14px;
    line-height: 18.61px;
    letter-spacing: 0.5px;

    // @media only screen and (min-width: 1440px) {
    //     font-size: 0.9722222222222222vw;
    //     line-height: 1.292361111111111vw;
    //     letter-spacing: 0.034722222222222224vw;
    // }

    & ~ span {
      font-size: 0.8333333333333334vw;
      line-height: 1.1111111111111112vw;
      margin-top: 0.4861111111111111vw;
    }
  }
  .title-sub-value {
    font-size: 24px;
    line-height: 31.9px;
    letter-spacing: 0.5px;
    font-weight: 700;

    // @media only screen and (min-width: 1440px) {
    //     font-size: 1.6666666666666667vw;
    //     line-height: 2.2152777777777777vw;
    //     letter-spacing: 0.034722222222222224vw;
    // }
  }
}
.chart-legend ::v-deep {
  ul {
    list-style: none;
    display: flex;
    justify-content: flex-end;
  }
  li {
    margin: 0 25px;

    // @media only screen and (min-width: 1440px) {
    //     margin: 0 1.7361111111111112vw;
    // }

    &:first-child span:before {
      background: #27ae60;
    }

    &:last-child span:before {
      background: #6171ff;
    }

    span {
      font-size: 12px;
      line-height: 16px;
      position: relative;

      // @media only screen and (min-width: 1440px) {
      //     font-size: 0.8333333333333334vw;
      //     line-height: 1.1111111111111112vw;
      // }

      &:before {
        content: "";
        width: 16px;
        height: 3px;
        display: inline-block;
        margin-bottom: 5px;
        margin-right: 10px;
        position: absolute;
        top: 50%;
        left: -16px;
        transform: translate(-50%, -50%);

        // @media only screen and (min-width: 1440px) {
        //     width: 1.1111111111111112vw;
        //     height: 0.20833333333333334vw;
        //     margin-right: 0.6944444444444444vw;
        //     left: -1.1111111111111112vw;
        // }
      }
    }
  }
}
</style>
